var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import InputField from "../../../../../../shared-library/components/inputField";
import EdButton from "../../../../../../web/components/generic/edbutton/edButton";
import { Col, Row } from "react-bootstrap";
import clientDi from "../../di/serviceLocator";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/salesjourney/components/Generic/ErrorNotification";
import Loader from "@frameworks/shared-library/components/Loader";
import debounce from "@frameworks/web/utils/debounce";
import { GenericDropdown, } from "@frameworks/shared-library/components/GenericDropdown";
var AddFamilyMemberPopUp = function (props) {
    var _a = __read(useState(""), 2), searchText = _a[0], setSearchText = _a[1];
    var _b = __read(useState(""), 2), addMemberError = _b[0], setAddMemberError = _b[1];
    var _c = __read(useState([]), 2), relationshipDropdown = _c[0], setRelationshipDropdown = _c[1];
    var _d = __read(useState(false), 2), showClientSearch = _d[0], setShowClientSearch = _d[1];
    var _e = __read(useState([]), 2), clientSearchResult = _e[0], setClientSearchResult = _e[1];
    var _f = __read(useState(), 2), familyMemberToBeAdded = _f[0], setFamilyMemberToBeAdded = _f[1];
    var _g = __read(useState(), 2), fieldError = _g[0], setFieldError = _g[1];
    var _h = __read(useState(false), 2), searchLoader = _h[0], setSearchLoader = _h[1];
    var getRelationshipDropdown = function () {
        var _a;
        clientDi.clients
            .getFamilyRelations({ ucc: (_a = props === null || props === void 0 ? void 0 : props.selectedAcount) === null || _a === void 0 ? void 0 : _a.uniqueCode })
            .then(function (resp) {
            var _a, _b;
            var dropdown = ((_b = (_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.map) === null || _b === void 0 ? void 0 : _b.call(_a, function (val) {
                var _a;
                return ({
                    title: val === null || val === void 0 ? void 0 : val.relationshipName,
                    value: (_a = val === null || val === void 0 ? void 0 : val.relationshipId) === null || _a === void 0 ? void 0 : _a.toString(),
                });
            })) || [];
            setRelationshipDropdown(dropdown);
        })
            .catch(function (err) { });
    };
    var getClientSearchResult = function (searchText) {
        var _a, _b;
        setSearchLoader(true);
        clientDi.clients
            .clientFamilySearch({
            searchText: searchText,
            individual: ((_a = props === null || props === void 0 ? void 0 : props.selectedAcount) === null || _a === void 0 ? void 0 : _a.pan)
                ? ((_b = props === null || props === void 0 ? void 0 : props.selectedAcount) === null || _b === void 0 ? void 0 : _b.pan[3].toUpperCase()) === "P"
                : true,
            page: 1,
            pageSize: 100,
        })
            .then(function (resp) {
            var _a;
            if (((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setClientSearchResult(resp === null || resp === void 0 ? void 0 : resp.data);
            }
            else {
                setClientSearchResult([]);
            }
            setSearchLoader(false);
        })
            .catch(function (err) {
            setSearchLoader(false);
            setClientSearchResult([]);
        });
    };
    var addMemberToFamily = function () {
        var _a, _b;
        props === null || props === void 0 ? void 0 : props.setPopupLoader(true);
        clientDi.clients
            .createFamilyMember({
            memberCode: familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.memberCode,
            memberName: familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.memberName,
            relationshipId: familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.relationshipId,
            familyId: (_a = props === null || props === void 0 ? void 0 : props.selectedFamilyDetails) === null || _a === void 0 ? void 0 : _a.family_id,
            headUcc: (_b = props === null || props === void 0 ? void 0 : props.selectedAcount) === null || _b === void 0 ? void 0 : _b.uniqueCode,
        })
            .then(function (resp) {
            var _a, _b, _c;
            if ((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.isMemberAdded) {
                props === null || props === void 0 ? void 0 : props.setIsShowAddFamilyMemberPopUp(false);
                props === null || props === void 0 ? void 0 : props.setPopupTitle(props === null || props === void 0 ? void 0 : props.currentFamilyName);
                setAddMemberError("");
                props === null || props === void 0 ? void 0 : props.getFamilyMembers((_b = props === null || props === void 0 ? void 0 : props.selectedFamilyDetails) === null || _b === void 0 ? void 0 : _b.family_code);
            }
            else {
                setAddMemberError((_c = resp === null || resp === void 0 ? void 0 : resp.data) === null || _c === void 0 ? void 0 : _c.errorMssg);
                props === null || props === void 0 ? void 0 : props.setPopupLoader(false);
            }
        })
            .catch(function (err) {
            props === null || props === void 0 ? void 0 : props.setPopupLoader(false);
        });
    };
    var handleAddBtnClick = function () {
        if ((familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.memberName) &&
            (familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.relationshipId)) {
            addMemberToFamily();
        }
        else {
            setFieldError({
                memberName: (familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.memberName)
                    ? ""
                    : "This field is Required",
                relationship: (familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.relationshipId)
                    ? ""
                    : "This field is Required",
            });
        }
    };
    useEffect(function () {
        getRelationshipDropdown();
    }, []);
    return (React.createElement("div", { className: "add-family-member-block d-flex flex-column justify-content-between" },
        (props === null || props === void 0 ? void 0 : props.popupLoader) && React.createElement(Loader, null),
        React.createElement("div", null,
            React.createElement("div", { className: "family-name pb-2" },
                React.createElement("div", { className: "DMSanN_16_400 txt_primaryGrey mb-2" }, "Family Name"),
                React.createElement(InputField, { className: "DMSanN_16_400 txt-midnight-blue disabled-name-field", placeholder: "Enter name", id: "name", name: "name", autoComplete: "off", type: "text", placeholderClassName: "", defaultValue: props === null || props === void 0 ? void 0 : props.currentFamilyName, onChangeEvent: function (e) { }, onBlur: function (error, event) { }, onKeyDown: function (e) { }, errorText: "", disabled: true })),
            React.createElement("div", { className: "add-members-details" },
                React.createElement(Row, { className: "mx-0 mb-4" },
                    React.createElement(Col, null,
                        React.createElement("div", { className: "DMSanM_14_500 txt_primaryGrey mb-2" }, "Client Name"),
                        React.createElement("div", { className: "position-relative" },
                            React.createElement(InputField, { className: "DMSanN_16_400 client-name", placeholder: "Search client by Name", id: "name", name: "name", autoComplete: "off", type: "text", placeholderClassName: "", defaultValue: searchText, onChangeEvent: function (e) {
                                    var _a;
                                    setAddMemberError("");
                                    setSearchText(e.target.value);
                                    if (((_a = e.target.value) === null || _a === void 0 ? void 0 : _a.length) > 2) {
                                        setShowClientSearch(true);
                                        debounce(function () {
                                            getClientSearchResult(e.target.value);
                                        }, 500)();
                                    }
                                    else if (e.target.value == "") {
                                        setShowClientSearch(false);
                                        setClientSearchResult([]);
                                    }
                                    setFieldError(__assign(__assign({}, fieldError), { memberName: "" }));
                                }, onBlur: function (error, event) { }, suffix: searchText ? (React.createElement("i", { className: "edel-icon-close hand_cursor", onClick: function () {
                                        setAddMemberError("");
                                        setSearchText("");
                                        setClientSearchResult([]);
                                        setShowClientSearch(false);
                                        setFamilyMemberToBeAdded(function (prev) {
                                            var updatedVal = __assign(__assign({}, prev), { memberName: "", memberCode: "" });
                                            return updatedVal;
                                        });
                                    } })) : (React.createElement("i", { className: "edel-icon-search1" })) }),
                            (fieldError === null || fieldError === void 0 ? void 0 : fieldError.memberName) && (React.createElement("span", { className: "DMSanN_16_400 red mt-1 d-flex" }, fieldError === null || fieldError === void 0 ? void 0 : fieldError.memberName)),
                            showClientSearch && (React.createElement("div", { className: "client-name-search-block" },
                                searchLoader && (React.createElement(Loader, { className: "client-search-loader" })),
                                (clientSearchResult === null || clientSearchResult === void 0 ? void 0 : clientSearchResult.length) > 0 ? (clientSearchResult === null || clientSearchResult === void 0 ? void 0 : clientSearchResult.map(function (result) {
                                    return (React.createElement("div", { className: "single-search-result d-flex justify-content-between align-items-center ".concat(!(result === null || result === void 0 ? void 0 : result.isDisabled) && "hover-state hand_cursor", " "), onClick: function (e) {
                                            e.stopPropagation();
                                            if (!(result === null || result === void 0 ? void 0 : result.isDisabled)) {
                                                setFieldError(__assign(__assign({}, fieldError), { memberName: "" }));
                                                setSearchText(result === null || result === void 0 ? void 0 : result.clientName);
                                                setFamilyMemberToBeAdded(function (prev) {
                                                    var updatedVal = __assign(__assign({}, prev), { memberName: result === null || result === void 0 ? void 0 : result.clientName, memberCode: result === null || result === void 0 ? void 0 : result.uniqueCode });
                                                    return updatedVal;
                                                });
                                                setShowClientSearch(false);
                                            }
                                        } },
                                        React.createElement("div", { className: "d-flex flex-column justify-content-center gap-1" },
                                            React.createElement("span", { className: "DMSanN_16_400 lh140 ".concat(result.isDisabled && "txt_dark_secondary-gray") }, result.clientName),
                                            React.createElement("span", { className: "Roboto_12_400  lh140 ".concat(result.isDisabled
                                                    ? "txt-footer-darkgray"
                                                    : "txt-DavySGray") }, (result === null || result === void 0 ? void 0 : result.isDisabled)
                                                ? "Rm - " + result.dealerEmpName
                                                : "Your Client")),
                                        React.createElement("div", { className: "search-icon-block" }, !result.isDisabled ? (React.createElement("i", { className: "edel-icon-point-arrow-up txt-DavySGray" })) : (React.createElement(React.Fragment, null)))));
                                })) : (React.createElement(ErrorNotification, { isOpen: true, errMsg: "No Data Found", displayType: ErrorDisplayType.INSECTION })))))),
                    React.createElement(Col, null,
                        React.createElement("div", { className: "DMSanM_14_500 txt_primaryGrey mb-2" }, "UCC (Auto Filled)"),
                        React.createElement(InputField, { className: "DMSanN_16_400", placeholder: "", id: "code", name: "code", autoComplete: "off", type: "text", placeholderClassName: "", defaultValue: familyMemberToBeAdded === null || familyMemberToBeAdded === void 0 ? void 0 : familyMemberToBeAdded.memberCode, onChangeEvent: function (e) { }, onBlur: function (error, event) { }, onKeyDown: function (e) { }, disabled: true }))),
                React.createElement(Row, { className: "mx-0 mt-2" },
                    React.createElement(Col, { className: "relationship-col" },
                        React.createElement("div", { className: "DMSanM_14_500 txt_primaryGrey mb-2" }, "Relationship"),
                        React.createElement(GenericDropdown, { align: "start", id: "", externalClassname: "relationship-dropdown", defaultVal: false, callUseEffect: false, defaultText: "Select Relationship", itemlist: relationshipDropdown, selectedValue: function (e) {
                                setFamilyMemberToBeAdded(function (prev) {
                                    var updatedVal = __assign(__assign({}, prev), { relationshipId: Number(e.value) });
                                    return updatedVal;
                                });
                                setFieldError(__assign(__assign({}, fieldError), { relationship: "" }));
                                setAddMemberError("");
                            } }),
                        (fieldError === null || fieldError === void 0 ? void 0 : fieldError.relationship) && (React.createElement("span", { className: "DMSanN_16_400 red mt-1 d-flex" }, fieldError === null || fieldError === void 0 ? void 0 : fieldError.relationship))),
                    React.createElement(Col, null)))),
        React.createElement("div", null,
            addMemberError && (React.createElement("div", { className: "DMSanN_16_400 txt-lightCarminePink mb-4 pb-2" }, addMemberError)),
            React.createElement("div", { className: "d-flex justify-content-end gap-4 add-member-btn-block" },
                React.createElement(EdButton, { value: "Back", btnTyp: "midnight-blue-border", onClick: function () {
                        props === null || props === void 0 ? void 0 : props.setPopupTitle(props === null || props === void 0 ? void 0 : props.currentFamilyName);
                        props === null || props === void 0 ? void 0 : props.setIsShowAddFamilyMemberPopUp(false);
                    } }),
                React.createElement(EdButton, { value: "Add", btnTyp: "midnight-blue", onClick: function () {
                        handleAddBtnClick();
                    }, disabled: !!addMemberError })))));
};
export default AddFamilyMemberPopUp;
